import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { Observable } from 'rxjs'

@Component({
    selector: 'eb-checkout-step-buttons',
    templateUrl: './eb-checkout-step-buttons.component.html',
    styleUrls: ['./eb-checkout-step-buttons.component.scss'],
    standalone: false
})
export class EbCheckoutStepButtonsComponent {
  @Input() disabled = false
  @Input() backButtonLabel = 'common.back'
  @Input() nextButtonLabel = 'common.continue'
  @Output() next: EventEmitter<any> = new EventEmitter()
  @Output() back: EventEmitter<any> = new EventEmitter()
  loaded$: Observable<boolean>

  constructor(public activeCartService: ActiveCartFacade) {
    this.loaded$ = this.activeCartService.isStable()
  }

  backEmit() {
    this.back.emit()
  }
  nextEmit() {
    this.next.emit()
  }
}
